const POPULAR_DOMAINS = [
  'naver.com',
  'gmail.com',
  'daum.net',
  'hanmail.net',
  'kakao.com',
  'nate.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
];

// 거리 계산으로는 안 잡히지만 자주 헷갈리는 조합
const KNOWN_MISTAKES = {
  'hanmail.com': 'hanmail.net',
  'daum.com': 'daum.net',
  'naver.net': 'naver.com',
  'nate.net': 'nate.com',
  'gmail.net': 'gmail.com',
};

// 학교·기관 메일은 형태가 제각각이라 추측하지 않는다.
const INSTITUTION_SUFFIXES = ['.go.kr', '.ac.kr', '.re.kr', '.or.kr', '.es.kr', '.ms.kr', '.hs.kr', '.sc.kr', '.kr'];

const editDistance = (a, b) => {
  const rows = a.length + 1;
  const cols = b.length + 1;
  const dist = Array.from({ length: rows }, (_, i) => [i, ...Array(cols - 1).fill(0)]);
  for (let j = 1; j < cols; j += 1) dist[0][j] = j;
  for (let i = 1; i < rows; i += 1) {
    for (let j = 1; j < cols; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      dist[i][j] = Math.min(dist[i - 1][j] + 1, dist[i][j - 1] + 1, dist[i - 1][j - 1] + cost);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        dist[i][j] = Math.min(dist[i][j], dist[i - 2][j - 2] + 1);
      }
    }
  }
  return dist[a.length][b.length];
};

/**
 * 흔한 메일 주소 오타(naver.con, gmial.com 등)를 찾아 고친 주소를 돌려준다.
 * 고칠 게 없거나 확신할 수 없으면 null.
 */
export const suggestEmailCorrection = (email) => {
  if (typeof email !== 'string') return null;
  const trimmed = email.trim();
  const at = trimmed.lastIndexOf('@');
  if (at < 1 || at === trimmed.length - 1) return null;

  const local = trimmed.slice(0, at);
  const domain = trimmed.slice(at + 1).toLowerCase();
  if (!domain.includes('.') || POPULAR_DOMAINS.includes(domain)) return null;

  if (KNOWN_MISTAKES[domain]) return `${local}@${KNOWN_MISTAKES[domain]}`;
  if (INSTITUTION_SUFFIXES.some((suffix) => domain.endsWith(suffix))) return null;

  let best = null;
  let bestDistance = Infinity;
  POPULAR_DOMAINS.forEach((candidate) => {
    const distance = editDistance(domain, candidate);
    if (distance < bestDistance) {
      best = candidate;
      bestDistance = distance;
    }
  });
  return best && bestDistance <= 2 ? `${local}@${best}` : null;
};
